/**
 * Desktop collection filter panel (snippets/km-desktop-filters.liquid).
 * The panel has no form fields of its own. Each control sets the matching field in the theme's
 * filter form (#filter) and calls the theme's processFilters(), which refetches the collection
 * section (this panel included, rendered from the new URL) and pushes the filters + sort_by into
 * the URL. Event handlers are delegated, so they survive those refetches.
 */
(function () {
  'use strict';

  var PRICE_MIN = 'filter.v.price.gte';
  var PRICE_MAX = 'filter.v.price.lte';
  var TYPE = 'filter.p.product_type';

  // UI-only state kept across refetches (the server re-renders the panel open and collapsed)
  var closed = {};
  var typesExpanded = false;

  function form() { return document.getElementById('filter'); }

  function apply() {
    var f = form();
    if (f && typeof window.processFilters === 'function') {
      window.processFilters();
      return;
    }
    // No theme filtering: load the URL with the form's values
    var params = f ? new URLSearchParams(new FormData(f)).toString() : '';
    window.location.search = params;
  }

  function busy(panel) { if (panel) panel.classList.add('is-busy'); }

  /* ---------- On sale ----------
   * Products tagged "sale", through Shopify's tag URL: /collections/{handle}/sale (keeps any other
   * tags, joined with +). processFilters() fetches from the current path, so the path is changed
   * first and the theme then refetches with the form's filters and sort. Also used by the mobile
   * Sort sheet (snippets/km-mobile-sort.liquid); this file loads on every collection page. */
  function saleParts() {
    var m = window.location.pathname.replace(/\/$/, '').match(/^(.*\/collections\/[^\/]+)(?:\/([^\/]+))?$/);
    if (!m) return null;
    return { base: m[1], tags: m[2] ? decodeURIComponent(m[2]).split('+').filter(Boolean) : [] };
  }
  window.kmSalePath = {
    isOn: function () {
      var parts = saleParts();
      return !!parts && parts.tags.indexOf('sale') !== -1;
    },
    set: function (on) {
      var parts = saleParts();
      if (!parts) return;
      var tags = parts.tags.filter(function (t) { return t !== 'sale'; });
      if (on) tags.push('sale');
      var path = parts.base + (tags.length ? '/' + tags.join('+') : '');
      if (form() && typeof window.processFilters === 'function') {
        history.replaceState(history.state, '', path + window.location.search);
        window.processFilters();
      } else {
        window.location.href = path + window.location.search.replace(/([?&])page=\d+&?/, '$1');
      }
    }
  };

  /* ---------- Sort ---------- */
  function setSort(value) {
    var f = form();
    if (!f) return;
    var radio = f.querySelector('input[name="sort_by"][value="' + value + '"]');
    if (radio) {
      f.querySelectorAll('input[name="sort_by"]').forEach(function (r) { r.checked = r === radio; });
    } else {
      var hidden = f.querySelector('input[type="hidden"][name="sort_by"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'sort_by';
        f.appendChild(hidden);
      }
      hidden.value = value;
    }
  }

  /* ---------- Product type ---------- */
  function typeInput(value) {
    var f = form();
    if (!f) return null;
    var inputs = f.querySelectorAll('input[name="' + TYPE + '"]');
    for (var i = 0; i < inputs.length; i++) if (inputs[i].value === value) return inputs[i];
    return null;
  }

  /* ---------- Price ---------- */
  function priceInputs() {
    var f = form();
    if (!f) return {};
    var lo = f.querySelector('input#min') || f.querySelector('input[name="' + PRICE_MIN + '"]');
    var hi = f.querySelector('input#max') || f.querySelector('input[name="' + PRICE_MAX + '"]');
    return { lo: lo, hi: hi };
  }

  function setPrice(lo, hi) {
    var p = priceInputs();
    if (!p.lo || !p.hi) return;
    p.lo.name = PRICE_MIN;
    p.hi.name = PRICE_MAX;
    p.lo.value = lo;
    p.hi.value = hi;
  }

  function clearPrice() {
    if (typeof window.clearRangeInputs === 'function') { window.clearRangeInputs(); return; }
    var p = priceInputs();
    if (p.lo) p.lo.removeAttribute('name');
    if (p.hi) p.hi.removeAttribute('name');
  }

  function clearAll() {
    if (typeof window.clearAllInputs === 'function') { window.clearAllInputs(); return; }
    clearPrice();
    var f = form();
    if (f) f.querySelectorAll('input[type="checkbox"]:checked').forEach(function (c) { c.checked = false; });
  }

  /* ---------- Price slider ---------- */
  function priceState(sec) {
    return {
      max: Number(sec.getAttribute('data-kdf-max')) || 0,
      lo: Number(sec.getAttribute('data-kdf-lo')) || 0,
      hi: Number(sec.getAttribute('data-kdf-hi')) || 0
    };
  }

  function drawPrice(sec, lo, hi) {
    var s = priceState(sec);
    var max = s.max || 1;
    var loPct = Math.max(0, Math.min(100, lo / max * 100));
    var hiPct = Math.max(0, Math.min(100, hi / max * 100));
    var fill = sec.querySelector('[data-kdf-fill]');
    fill.style.left = loPct + '%';
    fill.style.right = (100 - hiPct) + '%';
    var tLo = sec.querySelector('[data-kdf-thumb="lo"]');
    var tHi = sec.querySelector('[data-kdf-thumb="hi"]');
    tLo.style.left = loPct + '%';
    tHi.style.left = hiPct + '%';
    tLo.setAttribute('aria-valuenow', lo);
    tHi.setAttribute('aria-valuenow', hi);
    var iLo = sec.querySelector('[data-kdf-input="lo"]');
    var iHi = sec.querySelector('[data-kdf-input="hi"]');
    if (document.activeElement !== iLo) iLo.value = lo;
    if (document.activeElement !== iHi) iHi.value = hi;
    sec.setAttribute('data-kdf-lo', lo);
    sec.setAttribute('data-kdf-hi', hi);
  }

  function commitPrice(sec) {
    var s = priceState(sec);
    if (s.lo <= 0 && s.hi >= s.max) clearPrice();
    else setPrice(s.lo, s.hi);
    busy(sec.closest('[data-kdf]'));
    apply();
  }

  var drag = null;

  function valueAt(sec, clientX) {
    var slider = sec.querySelector('[data-kdf-slider]');
    var rect = slider.getBoundingClientRect();
    var pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    return Math.round(pct * priceState(sec).max);
  }

  function moveThumb(sec, which, value) {
    var s = priceState(sec);
    var lo = s.lo, hi = s.hi;
    if (which === 'lo') lo = Math.max(0, Math.min(value, hi));
    else hi = Math.min(s.max, Math.max(value, lo));
    drawPrice(sec, lo, hi);
  }

  document.addEventListener('pointerdown', function (e) {
    var slider = e.target.closest('[data-kdf-slider]');
    if (!slider) return;
    var sec = slider.closest('[data-kdf-sec="price"]');
    var s = priceState(sec);
    var v = valueAt(sec, e.clientX);
    // Nearest thumb (ties go to the side being dragged towards)
    var which = Math.abs(v - s.lo) <= Math.abs(v - s.hi) ? 'lo' : 'hi';
    if (s.lo === s.hi) which = v < s.lo ? 'lo' : 'hi';
    drag = { sec: sec, which: which };
    slider.setPointerCapture && slider.setPointerCapture(e.pointerId);
    moveThumb(sec, which, v);
    e.preventDefault();
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    moveThumb(drag.sec, drag.which, valueAt(drag.sec, e.clientX));
  });
  document.addEventListener('pointerup', function () {
    if (!drag) return;
    var sec = drag.sec;
    drag = null;
    commitPrice(sec);
  });

  // Keyboard on the thumbs: arrows move by $1 (Shift: $5), applied after a short pause
  var keyTimer = null;
  document.addEventListener('keydown', function (e) {
    var thumb = e.target.closest && e.target.closest('[data-kdf-thumb]');
    if (!thumb) return;
    var step = e.shiftKey ? 5 : 1;
    var delta = { ArrowLeft: -step, ArrowDown: -step, ArrowRight: step, ArrowUp: step }[e.key];
    if (!delta) return;
    e.preventDefault();
    var sec = thumb.closest('[data-kdf-sec="price"]');
    var which = thumb.getAttribute('data-kdf-thumb');
    var s = priceState(sec);
    moveThumb(sec, which, (which === 'lo' ? s.lo : s.hi) + delta);
    clearTimeout(keyTimer);
    keyTimer = setTimeout(function () { commitPrice(sec); }, 600);
  });

  // Min / Max boxes: digits only, applied on Enter or leaving the box
  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-kdf-input]');
    if (input) {
      input.value = input.value.replace(/[^0-9]/g, '');
      return;
    }
    var search = e.target.closest && e.target.closest('[data-kdf-type-search]');
    if (search) filterTypes(search);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-kdf-input]');
    if (!input) return;
    var sec = input.closest('[data-kdf-sec="price"]');
    var s = priceState(sec);
    var v = input.value === '' ? (input.getAttribute('data-kdf-input') === 'lo' ? 0 : s.max) : Number(input.value);
    moveThumb(sec, input.getAttribute('data-kdf-input'), v);
    var now = priceState(sec);
    sec.querySelector('[data-kdf-input="lo"]').value = now.lo;
    sec.querySelector('[data-kdf-input="hi"]').value = now.hi;
    commitPrice(sec);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-kdf-input]')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  /* ---------- Product type search + show more ---------- */
  function renderTypes(sec) {
    var list = sec.querySelector('[data-kdf-types]');
    var search = sec.querySelector('[data-kdf-type-search]');
    var more = sec.querySelector('[data-kdf-more]');
    var q = search ? search.value.trim().toLowerCase() : '';
    var rows = list.querySelectorAll('[data-kdf-type]');
    var shown = 0;
    rows.forEach(function (row, i) {
      var match = !q || row.getAttribute('data-kdf-name').indexOf(q) !== -1;
      var visible = match && (q || typesExpanded || i < 5);
      row.hidden = !visible;
      if (visible) shown++;
    });
    var empty = list.querySelector('[data-kdf-empty]');
    if (empty) empty.hidden = shown > 0;
    if (more) {
      more.hidden = !!q;
      more.classList.toggle('is-open', typesExpanded);
      more.querySelector('span').textContent = typesExpanded ? 'Show less' : more.getAttribute('data-more');
    }
  }

  function filterTypes(search) {
    renderTypes(search.closest('[data-kdf-sec="type"]'));
  }

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var panel = e.target.closest && e.target.closest('[data-kdf]');
    if (!panel) return;
    var t;

    if ((t = e.target.closest('[data-kdf-toggle]'))) {
      var sec = t.closest('[data-kdf-sec]');
      var isClosed = sec.classList.toggle('is-closed');
      t.setAttribute('aria-expanded', isClosed ? 'false' : 'true');
      closed[sec.getAttribute('data-kdf-sec')] = isClosed;
      return;
    }
    if ((t = e.target.closest('[data-kdf-more]'))) {
      typesExpanded = !typesExpanded;
      renderTypes(t.closest('[data-kdf-sec="type"]'));
      return;
    }
    if ((t = e.target.closest('[data-kdf-sort]'))) {
      if (t.classList.contains('is-on')) return;
      panel.querySelectorAll('[data-kdf-sort]').forEach(function (r) {
        r.classList.toggle('is-on', r === t);
        r.setAttribute('aria-checked', r === t ? 'true' : 'false');
      });
      setSort(t.getAttribute('data-kdf-sort'));
      busy(panel);
      apply();
      return;
    }
    if ((t = e.target.closest('[data-kdf-type]'))) {
      var input = typeInput(t.getAttribute('data-kdf-type'));
      if (!input) return;
      input.checked = !input.checked;
      t.classList.toggle('is-on', input.checked);
      t.setAttribute('aria-checked', input.checked ? 'true' : 'false');
      busy(panel);
      apply();
      return;
    }
    if ((t = e.target.closest('[data-kdf-chip-type]'))) {
      var chipInput = typeInput(t.getAttribute('data-kdf-chip-type'));
      if (chipInput) chipInput.checked = false;
      busy(panel);
      apply();
      return;
    }
    if ((t = e.target.closest('[data-kdf-sale]'))) {
      var saleOn = !window.kmSalePath.isOn();
      if (t.getAttribute('role') === 'switch') {
        t.classList.toggle('is-on', saleOn);
        t.setAttribute('aria-checked', saleOn ? 'true' : 'false');
      }
      busy(panel);
      window.kmSalePath.set(saleOn);
      return;
    }
    if (e.target.closest('[data-kdf-chip-price]')) {
      clearPrice();
      busy(panel);
      apply();
      return;
    }
    if (e.target.closest('[data-kdf-clear]')) {
      clearAll();
      busy(panel);
      if (window.kmSalePath.isOn()) window.kmSalePath.set(false);
      else apply();
      return;
    }
    if ((t = e.target.closest('[data-kdf-preset]'))) {
      var priceSec = t.closest('[data-kdf-sec="price"]');
      if (t.classList.contains('is-on')) {
        clearPrice();
      } else {
        var parts = t.getAttribute('data-kdf-preset').split('-');
        drawPrice(priceSec, Number(parts[0]), Number(parts[1]));
        var max = priceState(priceSec).max;
        if (Number(parts[0]) <= 0 && Number(parts[1]) >= max) clearPrice();
        else setPrice(Number(parts[0]), Number(parts[1]));
      }
      busy(panel);
      apply();
    }
  });

  /* ---------- Set up a freshly rendered panel ---------- */
  function init(panel) {
    if (panel.hasAttribute('data-kdf-ready')) return;
    panel.setAttribute('data-kdf-ready', '');
    Object.keys(closed).forEach(function (key) {
      var sec = panel.querySelector('[data-kdf-sec="' + key + '"]');
      if (!sec || !closed[key]) return;
      sec.classList.add('is-closed');
      sec.querySelector('[data-kdf-toggle]').setAttribute('aria-expanded', 'false');
    });
    var typeSec = panel.querySelector('[data-kdf-sec="type"]');
    if (typeSec) renderTypes(typeSec);
    var priceSec = panel.querySelector('[data-kdf-sec="price"]');
    if (priceSec) {
      var s = priceState(priceSec);
      drawPrice(priceSec, s.lo, s.hi);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-kdf]:not([data-kdf-ready])').forEach(init);
  }

  // processFilters swaps in new section HTML: set up the new panel when it appears
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
